<div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
  <div class="bn-content-pane-header flex h-11 min-h-11 items-center justify-between border-b border-surface-200 bg-transparent px-2 py-1">
    <h2 class="bn-content-pane-header__title flex items-center gap-2 text-sm font-medium text-surface-700 m-0">
      <i class="pi pi-user" aria-hidden="true"></i>
      Client Info
    </h2>
    <button
      type="button"
      class="bn-copilot-strip-btn"
      (click)="collapseContent.emit()"
      aria-label="Collapse content"
    >
      <i class="pi pi-angle-left"></i>
    </button>
  </div>
  <bn-tab-bar
    [tabs]="tabs()"
    [activeTabId]="activeTabId()"
    [mandatoryTabIds]="mandatoryTabIds()"
    storageContext="fa"
    (tabSelect)="tabSelect.emit($event)"
  />
  <bds-scroll-region
    class="flex-1 min-h-0"
    height="100%"
    ariaLabel="Client info content"
  >
    <div class="p-4 bg-surface-50 border-r border-surface-200">
      @switch (activeTabId()) {
        @case ('profile') {
          <bn-client-profile />
        }
        @case ('finances') {
          <bn-finances-tab />
        }
        @case ('review') {
          @if (clientGuid(); as guid) {
            <air-review-queue
              [clientGuid]="guid"
              [clientName]="clientName()"
              (needsAttention)="needsAttention.emit($event)"
            />
          } @else {
            <div
              class="flex flex-col items-center justify-center gap-3 text-surface-500 text-sm py-8 px-4"
              role="status"
            >
              <i class="pi pi-inbox text-4xl text-surface-300" aria-hidden="true"></i>
              <p class="text-center">Select a client to view their AI activity.</p>
            </div>
          }
        }
      }
    </div>
  </bds-scroll-region>
</div>
